const frontendConfig = {
   GOOGLE_MAPS_API_KEY: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
   GOOGLE_ANALYTICS_MEASUREMENT_ID: process.env.VUE_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID,
   GOOGLE_ADS_CONVERSION_TRACKING_TAG: process.env.VUE_APP_GOOGLE_ADS_CONVERSION_TRACKING_TAG,
   POSTMAIL_ACCESS_TOKEN: process.env.VUE_APP_POSTMAIL_ACCESS_TOKEN,
   AUTH0_DOMAIN: process.env.VUE_APP_AUTH0_DOMAIN,
   AUTH0_CLIENT_ID: process.env.VUE_APP_AUTH0_CLIENT_ID,
};

module.exports = {frontendConfig};